import type { ObservationValidationButtonProps } from "./observation-validation-button.type";

import { CheckCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useValidateObservation } from "@/entities/observation";

import "./observation-validation-button.style.less";

const ObservationValidationButton = ({
  observationId,
  disabled,
  loading,
  invalidateKeys,
}: ObservationValidationButtonProps) => {
  const { t } = useTranslation();

  const { validate, isPending } = useValidateObservation(observationId, {
    invalidateKeys,
  });

  return (
    <Button
      icon={<CheckCircleOutlined />}
      loading={loading || isPending}
      onClick={validate}
      disabled={disabled}
      className="observation-validation-button"
    >
      {t("observation:validation.validate")}
    </Button>
  );
};

export default ObservationValidationButton;
